import React from 'react'
import { modes } from 'utils/redux/config/modes'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import moment from 'moment'

export const Footer = ({ selectedMode }) => {
	const modeSettings = modes[selectedMode]
	return <div className={`c-footer u-bg--${modeSettings.color} u-padding`}>
		<div className='o-wrapper'>
			<div className='o-layout'>
				<div className='o-layout__item u-1/1 u-1/2@tablet u-push-1/2@tablet o-layout--right u-center-on-mobile'>
					<ul className='o-list-bare o-list-inline u-margin-none'>
						<li className='o-list-inline__item u-text--small u-text--white'><Link to={'/cookie-policy'}>Политика за ползване на "Бисквитки"</Link></li>
						<li className='o-list-inline__item u-text--small u-text--white u-margin-left@tablet'><Link to={'/contact'}>За реклама</Link></li>
					</ul>
				</div>
				<div className='o-layout__item u-1/1 u-1/2@tablet u-pull-1/2@tablet u-center-on-mobile u-margin-top u-margin-top-none@tablet'>
					<span className='u-text--small u-text--white'>{moment().format('YYYY')} Rates.bg Всички права запазени.</span>
				</div>
			</div>
		</div>
	</div>
}

Footer.propTypes = {
	selectedMode: PropTypes.string
}

export default Footer
